import { useEffect, useRef } from 'react'

export function RefreshAfterVersionChange() {
  useAutoReloadOnVersionChange()
  return null
}

function useAutoReloadOnVersionChange() {
  const currentVersion = useRef<string | null>(null)
  const intervalMs = 24 * 60 * 60 * 1000 // 24 hours in milliseconds

  useEffect(() => {
    fetch('/version.json')
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        currentVersion.current = data.version
      })
      .catch(() => {}) // Silently ignore network failures

    const interval = setInterval(() => {
      fetch('/version.json')
        .then((res) => (res.ok ? res.json() : Promise.reject()))
        .then((data) => {
          if (
            currentVersion.current &&
            data.version !== currentVersion.current
          ) {
            window.location.reload()
          }
        })
        .catch(() => {}) // Silently ignore network failures
    }, intervalMs)

    return () => clearInterval(interval)
  }, [])
}
